import { getInfo } from "@/apis/loginAndRegister/index.js"
import { sessionSto } from "@/util/sessionStorageManage.js"


const user = {
  state: {
    token: '',
    name: '',
    avatar: '',
    roles: [],
    permissions: [],
    rolekey:[]
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_ROLEKey: (state, roleKey) => {
      state.roleKey = roleKey
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    }
  },

  actions: {
    // // 登录
    // Login({ commit }, userInfo) {
    //   return login(userInfo).then(res => {
    //     setToken(res.token)
    //     commit('SET_TOKEN', res.token)
    //   })
    //   // return new Promise((resolve, reject) => {
    //   //   login(userInfo).then(res => {
    //   //     setToken(res.token)
    //   //     commit('SET_TOKEN', res.token)
    //   //     resolve()
    //   //   }).catch(error => {
    //   //     reject(error)
    //   //   })
    //   // })
    // },

    // // 短信登录
    // SmsLogin({ commit }, userInfo) {
    //   return new Promise((resolve, reject) => {
    //     smsLogin(userInfo).then(res => {
    //       setToken(res.token)
    //       commit('SET_TOKEN', res.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // // 注册及登录
    // Register({ commit }, userInfo) {
    //   return new Promise((resolve, reject) => {
    //     register(userInfo).then(res => {
    //       setToken(res.token)
    //       commit('SET_TOKEN', res.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },


    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(res => {
          console.log(state.token);
          const user = res.data
          console.log("user", this.user);
          sessionSto.$insertSessionStorage("userInfo", user)
          // const avatar = user.avatar == "" ? "": process.env.VUE_APP_BASE_API + user.avatar;
          // const roles = user.roles;
          commit('SET_NAME', user.name)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    
    // // 退出系统
    // LogOut({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     logout(state.token).then(() => {
    //       commit('SET_TOKEN', '')
    //       commit('SET_ROLES', [])
    //       commit('SET_PERMISSIONS', [])
    //       removeToken()
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // // 前端 登出
    // FedLogOut({ commit }) {
    //   return new Promise(resolve => {
    //     commit('SET_TOKEN', '')
    //     removeToken()
    //     resolve()
    //   })
    // },

    // // 测试
    // TheText({commit}) {
    //   return new Promise(resolve => {
    //     commit('SET_TOKEN', '欣喜的测试环节')
    //     setToken('欣喜的测试环节')
    //     removeToken()
    //     resolve()
    //   })
    // }



  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js